

import { defineComponent } from 'vue';


// Import Swiper styles
import {Swiper, SwiperSlide} from "swiper/swiper-vue";

import 'swiper/swiper.scss';
import 'swiper/modules/pagination.scss';
import 'swiper/modules/navigation.scss';

import { Navigation, Pagination, Mousewheel, Keyboard, Autoplay } from 'swiper/modules';

export default defineComponent({
  name: 'NiceWords',
  components : {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const onSwiper = (swiper: any) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Mousewheel, Keyboard, Autoplay],
    };
  },
  computed: {
    isMobile: function(){return screen.width <= 845}
  },

  mounted(){
    window.scrollTo(0, 0);
  }
});
